export {
  FetchAirbnbListingsModel,
  FetchAirbnbListingsModelType
} from './IntegrationModel';



// WEBPACK FOOTER //
// ./src/models/IntegrationModel/index.ts